export default "__VITE_ASSET__CVfjDyIJ__"